import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vi-progress-bar-determine',
  templateUrl: 'progress-bar-determine.component.html',
  styleUrls: ['progress-bar-determine.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViProgressBarDetermineComponent {
  @Input() isLoading: boolean = true;
  @Input() value: number = 1;
}
